var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSonnetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 349 71",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0 {\n\t\t\tfill: #ffffff;\n\t\t}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.9,71C13.5,71,3.3,67.9,0,64.1V52.9c5.9,2.1,12.9,3.8,21.7,3.8c7.1,0,9.1-1.6,9.1-4.1C30.8,44.2,0,51,0,28.1  c0-12,8.9-19.9,24.6-19.9c8.6,0,17.9,2.3,21.4,6.6v11.1c-4.2-1.3-12.9-3.2-20.4-3.2c-5.8,0-7.7,1.4-7.7,3.8  c0,8.6,30.8,1.1,30.8,25.6C48.8,64.2,38.4,71,22.9,71L22.9,71L22.9,71z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.4,8C65.1,8,53.7,19.6,53.7,39.5c0,20,11.4,31.5,29.7,31.5c18.4,0,29.7-11.6,29.7-31.5  C113.1,19.6,101.7,8,83.4,8z M83.4,55.8c-7.2,0-11.3-5.2-11.3-16.2s4.1-16.4,11.3-16.4c7.2,0,11.3,5.4,11.3,16.4  S90.6,55.8,83.4,55.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.4,69.7V14.5c7.8-3.4,19.8-6.6,29.8-6.6c17.9,0,25,9,25,23.8v38h-18V32.9c0-6.3-2.7-9.1-9-9.1  c-4,0-7.6,0.9-10,1.8v44.1L120.4,69.7L120.4,69.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.1,69.7V14.5c7.8-3.4,19.9-6.6,29.9-6.6c17.9,0,25,9,25,23.8v38h-18V32.9c0-6.3-2.7-9.1-9-9.1  c-4,0-7.6,0.9-10,1.8v44.1L185.1,69.7L185.1,69.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.3,8.1c-17.6,0-28.8,11.9-28.8,30.9c0,21.2,11.6,32,33.6,32c9,0,16.9-2.2,20.3-5.5V54.3  c-3.8,1.2-11.4,2.4-17.3,2.4c-9.7,0-16.2-2.9-17.7-10.5h37.5C305.7,19.9,294.5,8.1,276.3,8.1z M266,33.4c0.6-7.1,4.6-10.8,10.5-10.8  c6.7,0,9.6,4.1,9.6,10.8H266z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.6,70.8c-14.4,0-22.5-7.6-22.5-21.6v-43l17-6.2h0.9v10.1h18.5v14.3H329v22.8c0,6.8,3.1,9.4,9.9,9.4  c3.4,0,6.6-0.5,10.1-1.2v11.2C346.5,69,339.6,70.8,333.6,70.8L333.6,70.8L333.6,70.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonnetLogo);
export default __webpack_public_path__ + "static/media/sonnet-logo.e6bee26f273f1e07ad91792e0092abe5.svg";
export { ForwardRef as ReactComponent };